import React from 'react';

/**
 * FileField component - handles file input type
 */
function FileField({ field, index, value, onChange, formId }) {
    const fieldId = `${formId}_${field.name}_${index}`;

    return (
        <div>
            <input
                type="file"
                id={fieldId}
                onChange={(e) => onChange(index, e.target.files)}
                className="w-full px-3 py-2 bg-surface-2 text-content border border-line rounded-md focus:outline-none focus:ring-2 focus:ring-amber"
                accept={field.accept || '*'}
                multiple={field.multiple || false}
            />
            {value && value.length > 0 && (
                <div className="mt-2">
                    <p className="text-sm text-content-muted">Archivos seleccionados:</p>
                    {Array.from(value).map((file, fileIndex) => (
                        <p key={fileIndex} className="text-xs text-muted-deep">
                            📎 {file.name} ({(file.size / 1024).toFixed(1)} KB)
                        </p>
                    ))}
                </div>
            )}
        </div>
    );
}

export default FileField;
